"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getItem = function getItem(item) {
  var data = window.localStorage.getItem(item);
  return data;
};

var setItem = function setItem(name, item) {
  return window.localStorage.setItem(name, "".concat(item));
};

var removeItem = function removeItem(name) {
  return window.localStorage.removeItem(name);
};

var getSessionItem = function getSessionItem(item) {
  var data = window.sessionStorage.getItem(item);
  return data;
};

var setSessionItem = function setSessionItem(name, item) {
  return window.sessionStorage.setItem(name, "".concat(item));
};

var removeSessionItem = function removeSessionItem(name) {
  return window.localStorage.removeItem(name);
};

var clearAllStorage = function clearAllStorage() {
  window.localStorage.clear();
  window.sessionStorage.clear();
};

var _default = {
  clearAllStorage: clearAllStorage,
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  getSessionItem: getSessionItem,
  setSessionItem: setSessionItem,
  removeSessionItem: removeSessionItem
};
exports["default"] = _default;